var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpSoftNarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7489_55884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2196 5.2806L6.09782 0.929136",
    stroke: "black",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.06125 5.19695L5.80078 0.624199",
    stroke: "black",
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7489_55884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.91675,
    height: 6,
    fill: "white",
    transform: "translate(10.8438 6) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpSoftNarrow);
export default __webpack_public_path__ + "static/media/ArrowUpSoftNarrow.745e888ef30da711b269616d38253f81.svg";
export { ForwardRef as ReactComponent };